import { useContext } from 'react';
import {
  PdfViewerContext,
  PdfViewerContextType,
} from '../../providers/pdf-viewer-context';

export const usePdfViewer = (): PdfViewerContextType => {
  const context = useContext(PdfViewerContext);
  if (!context) {
    throw new Error('usePdfViewer debe ser utilizado dentro de un PdfViewerProvider');
  }
  return context;
};
